export const options = {
  width: 658,
  height: 304,
  chartArea: {
    width: 620,
    height: 264,
    left: 26,
    top: 16
  },
  fontSize: 10,
  fontName: 'Inter',
  colors: ['#4dc9f6', '#fbdf9c'],
  legend: {
    position: 'none'
  },
  hAxis: {
    minValue: 0,
    textStyle: {
      color: '#536283'
    },
    maxTextLines: 1,
    minTextSpacing: 3
  },
  vAxis: {
    minValue: 0,
    maxValue: 10,
    baselineColor: '#edf2f8',
    gridlines: {
      count: 10,
      color: '#edf2f8'
    },
    minorGridlines: {
      count: 0
    },
    textStyle: {
      color: '#536283'
    },
    maxTextLines: 1,
    minTextSpacing: 3
  },
  focusTarget: 'category',
  bar: {
    groupWidth: 25
  }
};
